'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSearchUrl = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _utils = require('./utils');

var _parameter = require('./parameter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module opensearch/url
 */

function isParameterMissing(parameterValues, parameter) {
  if (Object.prototype.hasOwnProperty.call(parameterValues, parameter.name)) {
    return false;
  } else if (parameter.isMulti) {
    var types = parameter.type;
    for (var i = 0; i < types.length; ++i) {
      var type = types[i];
      if (Object.prototype.hasOwnProperty.call(parameterValues, type)) {
        return false;
      }
    }
    return true;
  }
  return !Object.prototype.hasOwnProperty.call(parameterValues, parameter.type);
}

/**
 * Class to parse a single URL of an OpenSearchDescription XML document and
 * to create HTTP requests for searches.
 * @property {string} type The mime-type for the content the URL is referring to
 * @property {string} url The URL template or base URL
 * @property {array} parameters The template/request parameters of the URL
 * @property {string} method The HTTP method
 * @property {string} enctype The encoding type
 * @property {Number} indexOffset the index offset of this URL
 * @property {Number} pageOffset the page offset of this URL
 */

var OpenSearchUrl = exports.OpenSearchUrl = function () {
  /**
   * Create an OpenSearchUrl object
   * @param {string} type The mime-type for the content the URL is referring to
   * @param {string} url The URL template or base URL
   * @param {OpenSearchParameter[]} parameters The template/request parameters of the URL
   * @param {string} [method='GET'] The HTTP method
   * @param {string} [enctype='application/x-www-form-urlencoded'] The encoding type
   * @param {Number} [indexOffset=1] The index offset of this URL
   * @param {Number} [pageOffset=1] The page offset of this URL
   * @param {string[]} [relations=['results']] The relations of this URL.
   */
  function OpenSearchUrl(type, url) {
    var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'GET';
    var enctype = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'application/x-www-form-urlencoded';
    var indexOffset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    var _this = this;

    var pageOffset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
    var relations = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : ['results'];

    _classCallCheck(this, OpenSearchUrl);

    this._type = type;
    this._url = url;
    this._method = method;
    this._enctype = enctype;
    this._indexOffset = indexOffset;
    this._pageOffset = pageOffset;
    this._relations = relations;

    this._parameters = parameters;
    this._parametersByName = {};
    this._parametersByType = {};
    this._multiParameters = {};
    parameters.forEach(function (param) {
      var paramType = param.type;
      if (Array.isArray(paramType)) {
        for (var i = 0; i < paramType.length; ++i) {
          _this._parametersByType[paramType[i]] = param;
        }
      } else {
        _this._parametersByType[paramType] = param;
      }
      _this._parametersByName[param.name] = param;
    });
  }

  /**
   * The mime-type for the content the URL is referring to
   * @readonly
   */


  _createClass(OpenSearchUrl, [{
    key: 'hasParameter',


    /**
     * Returns whether the URL has a template parameter of the given type
     * @param {string} type The parameter type to check
     * @returns {boolean} Whether the URL has a parameter of that type
     */
    value: function hasParameter(type) {
      return Object.prototype.hasOwnProperty.call(this._parametersByType, type);
    }

    /**
     * Get the parameter of the specified type, if available
     * @param {string} type The parameter type to check
     * @returns {OpenSearchParameter} The parameter of the given type or null
     */

  }, {
    key: 'getParameter',
    value: function getParameter(type) {
      return this._parametersByType[type];
    }

    /**
     * Checks whether this URL is compatible with the given parameters
     * @param {object} parameters An object mapping the name or type to the value
     * @returns {boolean} Whether or not the URL is compatible with the given parameters
     */

  }, {
    key: 'isCompatible',
    value: function isCompatible(parameters) {
      var _this2 = this;

      var compatible = true;
      Object.keys(parameters).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(_this2._parametersByType, key) && !Object.prototype.hasOwnProperty.call(_this2._parametersByName, key)) {
          compatible = false;
        }
      });
      if (!compatible) {
        return false;
      }

      if (this.getMissingMandatoryParameters(parameters).length) {
        return false;
      }
      return true;
    }

    /**
     *
     */

  }, {
    key: 'getMissingMandatoryParameters',
    value: function getMissingMandatoryParameters(parameterValues) {
      return this.parameters.filter(function (parameter) {
        return parameter.mandatory;
      }).filter(function (parameter) {
        return isParameterMissing(parameterValues, parameter);
      });
    }

    /**
     *
     */

  }, {
    key: 'getMissingOptionalParameters',
    value: function getMissingOptionalParameters(parameterValues) {
      return this.parameters.filter(function (parameter) {
        return !parameter.mandatory;
      }).filter(function (parameter) {
        return isParameterMissing(parameterValues, parameter);
      });
    }

    /**
     *
     */

  }, {
    key: 'getUnsupportedParameterKeys',
    value: function getUnsupportedParameterKeys(parameters) {
      var _this3 = this;

      return Object.keys(parameters).filter(function (key) {
        return !Object.prototype.hasOwnProperty.call(_this3._parametersByType, key) && !Object.prototype.hasOwnProperty.call(_this3._parametersByName, key);
      });
    }

    /**
     * Checks and Serializes the given parameter values to an intermediate form:
     * a list of triplets: parameter name, parameter type, serialized value.
     * @param {object} values The parameter values to serialize
     * @returns {array[]} An array of triplets
     */

  }, {
    key: 'serializeValues',
    value: function serializeValues(values) {
      var _this4 = this;

      Object.keys(values).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(_this4._parametersByType, key) && !Object.prototype.hasOwnProperty.call(_this4._parametersByName, key)) {
          throw new Error('Invalid parameter \'' + key + '\'.');
        }
      });

      var missingMandatoryParameters = this.getMissingMandatoryParameters(values).map(function (parameter) {
        return parameter.type;
      });

      if (missingMandatoryParameters.length) {
        throw new Error('Missing mandatory parameters: ' + missingMandatoryParameters.join(', '));
      }
      var serialized = [];
      var parameters = this.parameters;
      for (var i = 0; i < parameters.length; ++i) {
        var parameter = parameters[i];
        if (parameter.isMulti) {
          var types = parameter.type;
          for (var j = 0; j < types.length; ++j) {
            var type = types[j];
            var value = void 0;
            if (Array.isArray(values[parameter.name]) || _typeof(values[parameter.name]) === 'object') {
              value = parameter.serializeValue(values[parameter.name], type);
            } else {
              value = parameter.serializeValue(values, type);
            }
            serialized.push([parameter.name, type, value]);
          }
        } else {
          var _value = void 0;
          if (Object.prototype.hasOwnProperty.call(values, parameter.name)) {
            _value = parameter.serializeValue(values[parameter.name]);
          } else if (Object.prototype.hasOwnProperty.call(values, parameter.type)) {
            _value = parameter.serializeValue(values[parameter.type]);
          } else {
            _value = '';
          }
          serialized.push([parameter.name, parameter.type, _value]);
        }
      }
      return serialized;
    }

    /**
     * Construct a {@link OpenSearchUrl} from a DOMNode
     * @param {DOMNode} node The DOM node from the OpenSearchDescription XML document
     * @returns {OpenSearchUrl} The constructed OpenSearchUrl object
     */

  }, {
    key: 'serialize',


    /**
     * Serialize the URL to a simple object.
     * @returns {object} The serialized URL
     */
    value: function serialize() {
      return {
        type: this._type,
        url: this._url,
        method: this._method,
        enctype: this._enctype,
        indexOffset: this._indexOffset,
        pageOffset: this._pageOffset,
        relations: this._relations,
        parameters: this._parameters.map(function (parameter) {
          return parameter.serialize();
        })
      };
    }

    /**
     * Deserialize a parameter from a simple object.
     * @param {object} values The serialized URL
     * @returns {OpenSearchUrl} The deserialized URL
     */

  }, {
    key: 'type',
    get: function get() {
      return this._type;
    }

    /**
     * The URL template or base URL
     * @readonly
     */

  }, {
    key: 'url',
    get: function get() {
      return this._url;
    }

    /**
     * The HTTP method
     * @readonly
     */

  }, {
    key: 'method',
    get: function get() {
      return this._method;
    }

    /**
     * The encoding type
     * @readonly
     */

  }, {
    key: 'enctype',
    get: function get() {
      return this._enctype;
    }

    /**
     * The index offset of this URL
     * @readonly
     */

  }, {
    key: 'indexOffset',
    get: function get() {
      return this._indexOffset;
    }

    /**
     * The page offset of this URL
     * @readonly
     */

  }, {
    key: 'pageOffset',
    get: function get() {
      return this._pageOffset;
    }

    /**
     * The page offset of this URL
     * @readonly
     */

  }, {
    key: 'relations',
    get: function get() {
      return this._relations;
    }

    /**
     * The template/request parameters of the URL
     * @readonly
     */

  }, {
    key: 'parameters',
    get: function get() {
      return this._parameters;
    }
  }], [{
    key: 'fromNode',
    value: function fromNode(node) {
      var parameterNodes = (0, _utils.getElements)(node, 'parameters', 'Parameter');
      var method = (0, _utils.getAttributeNS)(node, 'parameters', 'method');
      var enctype = (0, _utils.getAttributeNS)(node, 'parameters', 'enctype');
      var indexOffset = node.hasAttribute('indexOffset') ? parseInt(node.getAttribute('indexOffset'), 10) : 1;
      var pageOffset = node.hasAttribute('pageOffset') ? parseInt(node.getAttribute('pageOffset'), 10) : 1;
      var rel = node.getAttribute('rel');
      var relations = !rel || rel === '' ? undefined : rel.split(' ');

      var parsed = (0, _urlParse2.default)(node.getAttribute('template'), true);
      var parametersFromTemplate = Object.keys(parsed.query).map(function (name) {
        return _parameter.OpenSearchParameter.fromKeyValuePair(name, parsed.query[name]);
      }).filter(function (parameter) {
        return parameter;
      });
      var parametersFromNode = parameterNodes.map(_parameter.OpenSearchParameter.fromNode);

      var parametersNotInTemplate = parametersFromNode.filter(function (p1) {
        return !(0, _utils.find)(parametersFromTemplate, function (p2) {
          return p1.name === p2.name;
        });
      }).map(function (param) {
        // eslint-disable-next-line no-underscore-dangle, no-param-reassign
        param._mandatory = typeof param.mandatory === 'undefined' ? true : param.mandatory;
        return param;
      });

      // merge parameters from node and template
      var parameters = parametersFromTemplate.map(function (p1) {
        var p2 = (0, _utils.find)(parametersFromNode, function (p) {
          return p1.name === p.name;
        });
        if (p2) {
          return p1.combined(p2);
        }
        return p1;
      }).concat(parametersNotInTemplate);

      return new OpenSearchUrl(node.getAttribute('type'), node.getAttribute('template'), parameters, method, enctype, indexOffset, pageOffset, relations);
    }

    /**
     * Construct a {@link OpenSearchUrl} from a template URL
     * @param {string} type The mime-type
     * @param {string} templateUrl The template URL string.
     * @param {string} [method='GET'] The HTTP method
     * @param {string} [enctype='application/x-www-form-urlencoded'] The encoding type
     * @returns {OpenSearchUrl} The constructed OpenSearchUrl object
     */

  }, {
    key: 'fromTemplateUrl',
    value: function fromTemplateUrl(type, templateUrl) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
      var enctype = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'application/x-www-form-urlencoded';

      var parsed = (0, _urlParse2.default)(templateUrl, true);
      var parameters = Object.keys(parsed.query).map(function (name) {
        return _parameter.OpenSearchParameter.fromKeyValuePair(name, parsed.query[name]);
      }).filter(function (parameter) {
        return parameter;
      });
      return new OpenSearchUrl(type, templateUrl, parameters, method, enctype);
    }
  }, {
    key: 'deserialize',
    value: function deserialize(values) {
      return new OpenSearchUrl(values.type, values.url, values.parameters.map(function (parameterDesc) {
        return _parameter.OpenSearchParameter.deserialize(parameterDesc);
      }), values.method, values.enctype, values.indexOffset, values.pageOffset, values.relations);
    }
  }]);

  return OpenSearchUrl;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/url.js